import React, {useEffect, useRef, useState} from 'react'
import { MainWrapper } from '../component/MainWrapper'
import { Location } from './components/Tables/Location'
import { LocationDetailsView } from './components/LocationDetailsView'
import { ModelWrapperWithButton } from '../component/ModelWrapperWithButton'
import  LocationForm  from './components/LocationForm'
import { FormattedMessage } from 'react-intl'
import { getUserDetails } from 'sr/helpers/functions/getUserDetails'
import { getAddress } from 'sr/utils/api/individual/address/getAddress'
import ContentWithSpinner from 'sr/layout/common/ContentWithSpiner'
import { updateAddress } from 'sr/utils/api/individual/address/updateAddress'
import { SuccessMessage } from 'sr/helpers/functions/SuccessMessage'
import { LoaderFullScreen } from 'sr/layout/common/LoaderFullScreen'
import { Pageination } from 'sr/helpers/ui-components/Pageination'
import { Pagination } from 'app/pages/component/Pagination'
import { Button } from 'sr/helpers/ui-components/company/Button'
export const LocationManage = () => {
const [showModel, setShowModel] = useState(false)
const [activeComponent, setActiveComponent] = useState<any>({});
const [id, setId] = useState<string>('')
const [userId, setUserId] = useState<string>()
const childRef = useRef(null)
const [loader, setLoader] = useState('fetchData')
const [data, setData] = useState([])
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [totalPage, settotalPage] = useState<number>(0)

      const AllModel = [
        {name:LocationDetailsView, 
        label:"LocationDetailsView"},
       {name:LocationForm,
        label:"LocationForm"
       }
      ]
      const handleButtonClick = () => {
        if (childRef.current && childRef.current.submitForm) {
   
          
          childRef.current.submitForm()
       
          
        }
      };
      const openPopup = (index: any) => {  
        const activeComp = AllModel.filter(function (e, i) {
          return i == index
        });      
        setActiveComponent(activeComp[0]);
        setShowModel(true)
      };
      const HandleModel = (data) => {
        setShowModel(data)
    }
    const fetchLocation = async (userId)=> {
      setLoader('fetchData')
    try {
      const params = new URLSearchParams()
     if (userId) params.append('individual_id', userId)
      params.append('status!', 'deleted')
    const res = await getAddress(params)
     if(res?.success===true) {
      setData(res?.data)
      setLoader('')
      settotalPage(Math.ceil(res?.pagination?.total/limit))
     }
     else {
    setLoader('')
     }
    }
    catch(e:any) {
      setLoader('')
    }
    }
    const dataAddedHandle = (data)=> {
        if(data===true) {
          setShowModel(false)
          fetchLocation(userId)
        }
    }
    useEffect(()=> {
      const {user_id} = getUserDetails()
      setUserId(user_id)
    },[])
    useEffect(()=> {

if(userId) {
  fetchLocation(userId)
}
    },[userId])
    const handleDelete = async (id)=> {
      try {
      setLoader('apiprocess')
          const payLoad = {id:id, status:'deleted'}
          const res = await updateAddress(payLoad)
          if(res?.success===true) {
            SuccessMessage('API.SUCCESS.INDIVIDUAL.LOCATION.DELETED')
            setData(data?.filter((item)=> item?.id!== id))
            setLoader('')
          }
          else {
            setLoader('')
          }

    }
    catch(e:any) {
      setLoader('')
    }
  }


  return (
    <MainWrapper>
      <ContentWithSpinner loader={loader==='fetchData'} height='h-screen'>
        {loader==='apiprocess' && <LoaderFullScreen />}
    <div className='py-3 px-10 mx-auto'>
        <div className='mb-2'>
          <div className='flex justify-between items-center'>
          <div>
    <h1 className='text-2xl  border-r border-neutral-200 pr-4'><FormattedMessage id="INDIVIDUAL.MANAGE.ADDRESSES.TITLE" defaultMessage="Manage Addresses" /></h1>
    <p><FormattedMessage id="INDIVIDUAL.MANAGE.ADDRESSES.TEXT" defaultMessage="Use this page to manage your Addresses" /></p>
    </div>
   
   <Button onClick={() => openPopup(1)} text={<FormattedMessage id="INDIVIDUAL.MANAGE.ADDRESSES.BUTTON.TITLE" defaultMessage="Add Address" />}></Button>
   
    </div>
    
   </div>
    <Location handleDelete={handleDelete} data={data} Viewicon={()=> openPopup(0)} onClick = {(() => openPopup(1))} setId={setId}/>
    <Pagination page={page} totalPage={totalPage} setPage={setPage} />
     <ModelWrapperWithButton Save={handleButtonClick} nofooter = {activeComponent.name == LocationDetailsView ? true : false}  showModal={showModel} onCheckModel={HandleModel}>
             {<activeComponent.name ref={childRef} dataAddedHandle={dataAddedHandle} id={id}/>}
            </ModelWrapperWithButton>
        </div>
        </ContentWithSpinner>
        </MainWrapper>
  )
}
